export const hasAiAccess = user => Boolean(
  user?.subscription?.planCode !== 'core' && user?.subscription?.usage?.limit > 0
);
